<ng-container *ngIf="formGroup; else noForm">
  <div
    [formGroup]="formGroup"
    class="d-flex align-items-center justify-content-start"
    [ngClass]="{ 'flex-column-reverse': labelOnTop }"
  >
    <input
      type="checkbox"
      [id]="controlName"
      [formControlName]="controlName"
      class="form-control-input mr-1"
      style="transform: scale(1.2)"

    />
    <label
      [for]="controlName"
      class="form-control-label"
      [ngClass]="{ 'ml-1': !labelOnTop }"
      style="margin-bottom: 0"
      >{{ label }}</label
    >
  </div>
</ng-container>

<ng-template #noForm>
  <div
    class="d-flex align-items-center justify-content-start"
    [ngClass]="{
      'flex-column-reverse': labelOnTop,
      'custom-switch': toggleSwitch
    }"
  >
    <input
      type="checkbox"
      class="form-control-input"
      [id]="id"
      [(ngModel)]="value"
      [ngClass]="{ 'custom-control-input': toggleSwitch }"
      (change)="onNewValue(value)"
    />
    <label
      [for]="id"
      class="form-control-label"
      [ngClass]="{ 'ml-1': !labelOnTop, 'custom-control-label': toggleSwitch }"
      style="margin-bottom: 0"
      >{{ label }}</label
    >
  </div>
</ng-template>
